import Vue from "vue";
import Router from "vue-router";
const LoginComponent = () => import("./views/Login.vue");
const SignUpComponent = () => import("./views/SignUp.vue");
const AccountActivation = () => import("./views/AccountActivation.vue");
const ResetPasswordComponent = () => import("./views/ResetPassword.vue");
const Home = () => import("./views/Home.vue");
const User = () => import("./views/User.vue");
const Icon = () => import("./views/Icon.vue");
const Costcenter = () => import("./views/Costcenter.vue");
const Location = () => import("./views/Location.vue");
const Dsgvo = () => import("./views/Dsgvo.vue");
const Report = () => import("./views/Report.vue");
const Survey = () => import("./views/Survey.vue");
const SupportSession = () => import("./views/SupportSession.vue");
const Notifications = () => import("./views/Notifications.vue");

Vue.use(Router);

export default new Router({
  mode: "hash",
  routes: [
    // {
    //   path: "/",
    //   redirect: {
    //     name: "cryptologin",
    //   },
    // },
    {
      path: "/",
      redirect: {
        name: "login",
      },
    },
    {
      path: "/login",
      name: "login",
      component: LoginComponent,
    },
    {
      path: "/support-session",
      name: "supportSession",
      component: SupportSession,
    },
    // {
    //   path: "/login",
    //   name: "login",
    //   component: CryptoLogin,
    // },
    {
      path: "/sign-up",
      name: "signUp",
      component: SignUpComponent,
    },
    {
      path: "/activate-account/:token?",
      component: AccountActivation,
      name: "accountActivation",
    },
    {
      path: "/reset-password",
      name: "resetPassword",
      component: ResetPasswordComponent,
    },
    {
      path: "/confirm-password-reset/:token?",
      name: "resetPasswordConfirm",
      component: ResetPasswordComponent,
    },
    {
      path: "/home",
      icon: "mdi-home",
      color: "blue darken-2",
      name: "home",
      component: Home,
    },
    {
      path: "/notifications",
      name: "notifications",
      component: Notifications,
    },
    {
      path: "/user",
      name: "User",
      icon: "account_box",
      color: "deep-orange",
      component: User,
    },
    {
      path: "/icon",
      name: "Icon",
      icon: "mdi-archive",
      color: "green",
      component: Icon,
    },
    {
      path: "/costcenter",
      name: "Costcenter",
      icon: "mdi-cash-check",
      color: "cyan",
      component: Costcenter,
    },
    {
      path: "/loc",
      name: "location",
      icon: "business",
      color: "blue darken-2",
      component: Location,
    },

    {
      path: "/report",
      name: "report",
      icon: "mdi-chart-box-outline",
      color: "orange darken-2",
      component: Report,
    },
    {
      path: "/dsgvo",
      name: "Dsgvo",
      component: Dsgvo,
    },
   
    {
      path: "/survey",
      icon: "mdi-home",
      color: "blue darken-2",
      name: "survey",
      component: Survey,
    },

    // {
    //   path: "/cryptologin",
    //   name: "cryptologin",
    //   component: CryptoLogin,
    // },
  ],
});
